import { Injectable } from '@angular/core';

import { requestName } from 'src/assets/common/enums/request-names.g';
import { EntityKeyName, _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { IUserDto, UserDto } from 'src/assets/common/models/user-dto.g';
import { IAccountData, AccountData } from '../account/models/account-data';
import { accountForm, IAccountForm } from '../account/models/account-form';

@Injectable()
export class AccountFormModelService
    extends _FormModelService
{
    override controls$$ = this._computed_controls$$;
    override dataModel$ = this._dataModel$;
    override dataModel$$ = this._dataModel$$;
    override dtoModel$$ = this._computed_dtoModel$$;
    override form$$ = this._form$$;
    override photo$$ = this._photo$$;
    override photos$$ = this._photos$$;
    
    override controlId_focus = this._controlId_focus;
    override form = accountForm;
    override keyName_entity: EntityKeyName = 'id';
    override requestNames = requestName.details;

    override dataModel_alter(dtoModel?: IUserDto | null): IAccountData | null
    override dataModel_alter(dataModel: IAccountData, formModel: IAccountForm): IAccountData | null
    override dataModel_alter(value?: IUserDto | IAccountData | null, formModel?: IAccountForm | null): IAccountData | null {
        if (!!formModel) {
            const _dataModel = value as IAccountData;
            return AccountData.create(_dataModel, formModel);
        } else {
            const _dtoModel = value as IUserDto;
            return AccountData.create(_dtoModel);
        }
    }

    override dtoModel_alter(dataModel: IAccountData): IUserDto | null {
        return UserDto.create(dataModel);
    }
}
